import { define } from 'wicked-elements'

/**
 * We use <label> to cover the default option.
 * Once a different value is selected, we hide the label
 */

define('[data-component~="select"]', {
  init () {
    this.$select = this.element.querySelector('select')
    this.$label = this.element.querySelector('label')
    this.$clear = this.element.querySelector('.jps-input-clear')
    this.handleChange = this.handleChange.bind(this)
    this.handleChange()
    this.handleClearClick = this.handleClearClick.bind(this)
  },
  connected () {
    this.$select.addEventListener('change', this.handleChange)
    this.$clear.addEventListener('click', this.handleClearClick)
  },
  disconnected () {
    this.$select.removeEventListener('change', this.handleChange)
    this.$clear.removeEventListener('click', this.handleClearClick)
  },
  handleChange () {
    if (this.$select.selectedIndex) {
      this.$label.classList.add('sr-only')
      this.$clear.classList.remove('hidden')
    } else {
      this.$label.classList.remove('sr-only')
      this.$clear.classList.add('hidden')
    }
  },
  handleClearClick (e) {
    e.preventDefault()
    this.$select.selectedIndex = 0
    this.$select.dispatchEvent(new Event('change'))
  }
})